import React from 'react';
import Layout from '~/components/Layout';

interface ISettingsProps {}

const Settings: React.FunctionComponent<ISettingsProps> = () => {
  return (
    <Layout>
      <div>This is Settings page</div>
    </Layout>
  );
};

export default Settings;
